const AMADEUS = '1A';
const TRAVELFUSION = 'TF';
const TRAVELPORT = 'TP';
const VUELING = 'VY';
const RYANAIR = 'FR';
const ANCILLARIES_POSTBOOKING_PROVIDERS = [AMADEUS, TRAVELPORT];

const mapSegmentsToProviders = (segments) => segments
    ? segments.map((segment) => segment.sections).flat()
        .map((section) => section.provider || section.providerCode)
    : [];

const hasAmadeusProvider = (section) => {
    const provider = Odigeo._.get(section, 'provider');
    return provider === AMADEUS;
};

const shouldMoveBagAndSeats = (segments) => {
    const providerSegments = mapSegmentsToProviders(segments);
    return providerSegments.length > 0
        && !providerSegments.some((provider) => ANCILLARIES_POSTBOOKING_PROVIDERS.includes(provider));
};

const seatMapPriceFrom = (segments) => mapSegmentsToProviders(segments)
    .some((provider) => TRAVELFUSION === provider);

const getValidatingCarrier = (section) => {
    const carrier = Odigeo._.get(section, 'section.carrier');
    const gdsValidatingCarrier = Odigeo._.get(section, 'section.validatingCarrier');

    return hasAmadeusProvider(section)
        ? gdsValidatingCarrier
        : carrier;
};

module.exports = {
    PROVIDERS: {AMADEUS, TRAVELFUSION, TRAVELPORT, VUELING, RYANAIR},
    shouldMoveBagAndSeats,
    seatMapPriceFrom,
    getValidatingCarrier,
};
